import React from 'react';

export const StatCard = ({ title, value, icon, color }) => {
  const getColorClasses = (color) => {
    const colorMap = {
      blue: 'bg-blue-50 bg-blue-100 text-blue-600',
      green: 'bg-green-50 bg-green-100 text-green-600',
      yellow: 'bg-yellow-50 bg-yellow-100 text-yellow-600',
      purple: 'bg-purple-50 bg-purple-100 text-purple-600',
      red: 'bg-red-50 bg-red-100 text-red-600',
      indigo: 'bg-indigo-50 bg-indigo-100 text-indigo-600',
    };
    return colorMap[color] || colorMap.blue;
  };

  const [bgColor, iconBgColor, iconColor] = getColorClasses(color).split(' ');

  return (
    <div className={`${bgColor} p-4 rounded-lg`}>
      <div className="flex items-center">
        <div className={`p-2 ${iconBgColor} rounded-lg`}>
          <i className={`fa-solid ${icon} ${iconColor}`}></i>
        </div>
        <div className="ml-3">
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <p className="text-lg font-semibold text-gray-900">{value}</p>
        </div>
      </div>
    </div>
  );
}; 